import * as React from 'react';
import * as c from 'models/constants';
import { translate } from 'react-i18next';
const { connect } = require('react-redux');
import { IStore } from 'redux/IStore';
import { InfoPage, PortalOneColumnLayout } from 'components/PortalStructure';
import { InfoPageHeaderSection, InfoPageSection, InfoPageImage, InfoPageHeaderTitle } from 'components';
import { Helmet } from 'react-helmet';
const { asyncConnect } = require('redux-connect');

interface IProps {
	baseUrlClient?: string;
}

@asyncConnect([
	{
		promise: () => {
			return Promise.all([]);
		},
	},
])
@connect((state: IStore) => ({
	baseUrlClient: state.fetchDefault.baseUrlClient,
}))
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class PortalPaymentOptionsEN extends React.Component<IProps, any> {
	public render() {
		const siteTitle = 'Payment Options';
		const siteDescription = 'Payment Options default description';
		const siteKeywords = 'Payment Options default keywords';
		const siteImage = this.props.baseUrlClient + '/images/logo.png';
		const siteUrl = this.props.baseUrlClient + '/paymentoptions/en';

		return (
			<PortalOneColumnLayout>
				<InfoPage>
					<InfoPageHeaderSection>
						<InfoPageHeaderTitle>Payment Options</InfoPageHeaderTitle>
					</InfoPageHeaderSection>
					<InfoPageSection>
						<p>
							Making payments for your order is easy. Simply, use any of the payment apps listed below, except Apple
							Pay*.
						</p>
						<InfoPageImage imageUrl={require('../PaymentOptions/images/PaymentOptions.png')} />
						<p>
							Rest assured, we ensure utmost confidentiality, and therefore, your important details are kept safe and
							secure.
						</p>
						<p>
							Additionally, we have zero-tolerance for fraud. This is the reason why both credit and debit card payments
							are subject to proper authorization and validation by both us (via Tripe) and the card issuer.
						</p>
						<p>
							*It is important to mention here that Apple Pay is only available as a payment method in supported
							countries on our application and website when you are using a supported device. If Apple Pay is available
							for your location, this payment option will be made available at checkout.
						</p>
					</InfoPageSection>
				</InfoPage>
				<Helmet
					title={siteTitle}
					link={[{ rel: 'canonical', href: siteUrl }]}
					meta={[
						{ property: 'og:title', content: siteTitle },
						{ property: 'og:image', content: siteImage },
						{ property: 'og:description', content: siteDescription },
						{ property: 'og:url', content: siteUrl },
						{ name: 'title', content: siteTitle },
						{ name: 'description', content: siteDescription },
						{ name: 'keywords', content: siteKeywords },
					]}
				/>
			</PortalOneColumnLayout>
		);
	}
}

export { PortalPaymentOptionsEN };
